import { render, staticRenderFns } from "./ShipmentCreate.vue?vue&type=template&id=27207def"
import script from "./ShipmentCreate.vue?vue&type=script&lang=js"
export * from "./ShipmentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports